import React from 'react';
import {
  Box,
} from '@mui/material';

function Infos2() {
  return (
    <Box />
  );
}

export {
  Infos2,
};
